import { shallowRef } from 'vue';
import Global from '@garmin/support-center-components/components/global/global.vue';
import Transition from '@garmin/support-center-components/components/transition/transition.vue';
import Loader from '@garmin/support-center-components/components/loader/loader.vue';
import HeroBanner from '@garmin/support-center-components/components/hero-banner/hero-banner.vue';
import { UrlUtils } from '@garmin/support-utils';

import './transition.scss';

export default {
  components: {
    Loader,
  },
  created() {
    this.$store.dispatch('fetchSystemsAvailability');
    this.$store.dispatch('fetchProductListByLocale');
    this.$store.dispatch(
      'fetchComponentizedTranslations',
      {
        pathsForEntryIds: ['banner', 'scContactSection[0]'],
      },
    );
    this.$store.commit('productSearchErrorOverridesUpdate', this.$store.state.translations);
    this.$store.commit('productSearchOverridesUpdate', this.$store.state.translations);
  },
  methods: {
    getTransitionHeroBannerUrl() {
      let transitionHeroBannerUrl = false;
      const { translations: { transitionPages } } = this.$store.getters;
      const focus = new URLSearchParams(window.location.search).get('focus');

      switch (focus) {
        case 'manuals':
          transitionHeroBannerUrl = transitionPages.scTransitionPages.manualsImage;
          break;
        case 'videos':
          transitionHeroBannerUrl = transitionPages.scTransitionPages.videosImage;
          break;
        case 'software':
          transitionHeroBannerUrl = transitionPages.scTransitionPages.softwareImage;
          break;
        case 'topics':
          transitionHeroBannerUrl = transitionPages.scTransitionPages.contactSupportImage;
          break;
        default:
          transitionHeroBannerUrl = transitionPages.scTransitionPages.manualsImage;
          break;
      }

      return transitionHeroBannerUrl;
    },

    hideProductIdentificationHelpLinks() {
      return true;
    },
  },
  data() {
    return {
      children: [{
        component: shallowRef(Global),
        children: [],
      }, {
        component: shallowRef(Transition),
        customProps: {
          hideProductIdentificationHelpLinks: this.hideProductIdentificationHelpLinks(),
          redirectBaseUrl: `${UrlUtils.getBaseUrl()}/`,
          helpIconForeground: 'dark',
        },
        children: [{
          component: shallowRef(HeroBanner),
          customProps: {
            imageSources: [],
            fallback: this.getTransitionHeroBannerUrl(),
          },
          children: [],
        }],
      }],
    };
  },
};
